<script lang="ts">
	import { beforeNavigate } from '$app/navigation';
	import { contentFade, contentTransitionsData } from '$lib/animations/ContentTransitions';
	import type { Snippet } from 'svelte';

	let {
		children,
		style,
		key
	}: {
		children: Snippet;
		style?: string;
		key: string;
	} = $props();

	beforeNavigate(() => {
		contentTransitionsData.scroll = window.scrollY;
	});
</script>

{#key key}
	<div class="page-wrapper" {style} in:contentFade out:contentFade>
		{@render children()}
	</div>
{/key}

<style lang="scss">
	div {
		grid-row: 1;
		grid-column: 1;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: start;
		min-width: 0;
		width: 100%;
		background-color: $colorBackground;
		z-index: 1;
	}
</style>
